import { faTruckFast } from "@jewlr/sharp-light-svg-icons/faTruckFast"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Shimmer from "components/ui/shimmer"
import { IS_NA } from "helpers/application"
import { showHolidayShippingInfoPDP } from "helpers/holiday"
import { cn } from "styles/utils"

const Promo = () => {
  const prefStore = useSelector((state) => state.wizardUI.prefStore)
  const wizardLoading = useSelector((state) => state.wizard.loading)
  const ship = useSelector((state) => state.wizard.shipping?.main)
  const outOfStock = useSelector(
    (state) => state.wizard.header?.product_out_of_stock
  )
  const holidayDelivery = useSelector(
    (state) => state.wizard.shipping?.main?.available_holiday_delivery
  )

  const pdpPricingHierarchyExp = useSelector(
    (state) => state.experiment.pdpPricingHierarchy.variant_id
  )

  if (outOfStock) return null
  if (!showHolidayShippingInfoPDP() || holidayDelivery == false) {
    return null
  }
  if (
    wizardLoading ||
    !prefStore ||
    (showHolidayShippingInfoPDP() && holidayDelivery == undefined)
  ) {
    return pdpPricingHierarchyExp === 1 ? (
      <Shimmer className="h-22 tablet:mx-0 tablet:w-full -mx-16 mb-10 w-screen" />
    ) : (
      <Shimmer
        className="tablet:w-full tablet:mb-8 w-(--base-width)"
        style={{
          "--base-width": "150px",
          height: "28px",
        }}
      />
    )
  }

  let message = null

  if (holidayDelivery) {
    let dateMsg =
      ship.delivery_dates?.length > 0
        ? ship.delivery_dates[
            ship.delivery_dates.length === 2 && !IS_NA() ? 1 : 0
          ].date
        : ship.delivery_date_range?.length > 0
          ? ship.delivery_date_range[0]
          : ""

    if (dateMsg) {
      message = (
        <>
          <FontAwesomeIcon
            className={cn(
              pdpPricingHierarchyExp === 1
                ? "text-12 mr-6 align-text-bottom"
                : "text-15 mr-4 align-text-bottom"
            )}
            icon={faTruckFast}
          />
          Get it by {dateMsg} for {sl.config.guaranteed_holiday_alias}
        </>
      )
    }
  }

  if (!message) return null

  return pdpPricingHierarchyExp === 1 ? (
    <div className="text-12 leading-14 h-22 bg-light-pink tablet:mx-0 tablet:w-full -mx-16 mb-10 flex w-screen items-center justify-center px-16 font-semibold">
      {message}
    </div>
  ) : (
    <div
      className="bg-olive tablet:mb-8 tablet:w-full flex w-fit items-center justify-center px-16 text-white"
      style={{ height: "28px" }}
    >
      <p className="text-15 leading-15 font-semibold">{message}</p>
    </div>
  )
}

export default Promo
